import React from 'react'
import "./UserInfoSec.css"
import Testimonials from '../../Testimonials/Testimonials'
import { Col, Container, Row } from 'react-bootstrap'
import { TestimonialsData03 } from '../../Testimonials/TestimonialsData'
import { fadeIn } from "../../..//Functions/GlobalAnimations";
import { ParagraphComp } from '../../ParagraphComp/ParagraphComp'

const UserInfoSec = () => {
    return (<>
        <section className="bg-[#f7f7f7] py-[70px] max-sm:py-[70px] overflow-hidden lg:py-[70px] md:py-[70px] sm:py-[50px]">
            <Container>
                <Row className="justify-center">
                    <Col
                        lg={12}
                        md={10}
                        sm={9}
                        className="text-center max-sm:mb-[50px] mb-[100px] md:mb-16"
                    >
                        <h2 className="heading-5 max-sm:text-3xl font-extrabold text-[#262b35] tracking-[-1px] mb-[15px] infoSecFont">
                            Understand how institutions and individuals are using GuideStar India
                        </h2>
                        <ParagraphComp className='max-sm:text-lg text-black lg:w-[85%] m-auto' text='Our NPO information, due diligence and insights are the key differentiators guiding strategic philanthropy, organisation development and ecosystem building.' />
                    </Col>
                </Row>
                <Row className="justify-center">
                    <Col md={12} sm={8}>
                        <Testimonials
                            grid="row-cols-1 row-cols-md-2 row-cols-lg-3 gap-y-[30px] justify-center eventsconference-testimonials"
                            theme="testimonials-style-03"
                            data={TestimonialsData03}
                            animation={fadeIn}
                        />
                    </Col>
                </Row>
            </Container>
        </section>
    </>
    )
}

export default UserInfoSec